import * as Yup from 'yup'

import { i18n } from 'i18n-web/i18next'
import { phoneNumberSchema, passwordSchema } from 'i18n-web/validators'

const validationSchema = (
  countryCode,
  hasNamePronunciation,
  facebookToken,
  appleToken,
  appleNameAvailable,
  passwordRules
) =>
  Yup.object().shape({
    name: Yup.string()
      .min(2, i18n.t('signUp.form.name.error'))
      .required(
        !facebookToken &&
          appleNameAvailable !== 'true' &&
          i18n.t('common.form.error.required')
      ),
    namePronunciation: Yup.string()
      .min(2, i18n.t('signUp.form.name.error'))
      .required(hasNamePronunciation && i18n.t('common.form.error.required')),
    email: Yup.string()
      .email(i18n.t('signUp.form.email.error'))
      .required(!facebookToken && i18n.t('common.form.error.required')),
    password: passwordSchema({ passwordRules, facebookToken, appleToken }),
    confirmPassword: Yup.string()
      .oneOf(
        [Yup.ref('password'), null],
        i18n.t('signUp.form.confirmPassword.error')
      )
      .required(
        !facebookToken && !appleToken && i18n.t('common.form.error.required')
      ),
    phoneNumber: phoneNumberSchema({ countryCode }),
    discountCode: Yup.string().required(false),
    acceptedTerms: Yup.boolean().oneOf(
      [true],
      i18n.t('signUp.form.terms.error')
    ),
  })

export default validationSchema
